import OptionsForm from './OptionsForm';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react';
import { Option } from 'owa-options-core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./OptionsFull.scss');

export interface OptionsPaneProps {
    options: Option[];
}

@observer
export default class OptionsPane extends React.Component<OptionsPaneProps, {}> {
    private optionFormRefs: { [key: string]: OptionsForm } = {};
    private settingsForm: HTMLDivElement;

    render() {
        return (
            <div ref={ref => (this.settingsForm = ref)} className={styles.settingsForm}>
                {this.props.options.map(option => (
                    <OptionsForm
                        option={option}
                        key={option.key}
                        ref={ref => (this.optionFormRefs[option.key] = ref)}
                    />
                ))}
            </div>
        );
    }

    componentDidMount() {
        this.scrollToSelectedOption();
    }

    componentDidUpdate(prevProps: OptionsPaneProps) {
        if (this.props !== prevProps) {
            // We changed options, so reset the scroll position
            this.scrollToSelectedOption();
        }
    }

    private scrollToSelectedOption() {
        let selectedOption: OptionsForm;
        let currentOptionKey = getStore().currentOptionKey;

        if (currentOptionKey && (selectedOption = this.optionFormRefs[currentOptionKey])) {
            this.settingsForm.scrollTop = (ReactDOM.findDOMNode(
                selectedOption
            ) as HTMLElement).offsetTop;
        } else {
            this.settingsForm.scrollTop = 0;
        }
    }
}
